import React from 'react';
import {
  columnConditions,
  columnLocation,
  columnRequested,
  columnStatus,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';

const WorkspacesTableColumns = ({ columns, items }) => (
  <NameDescriptionColumns columns={columns} entity="workspace" items={items}>
    {hasColumn(columns, columnLocation) && (<UnsortedColumn columnId={columnLocation} />)}
    {hasColumn(columns, columnConditions) && (<UnsortedColumn columnId={columnConditions} />)}
    {hasColumn(columns, columnStatus) && (<UnsortedColumn columnId={columnStatus} />)}
    {hasColumn(columns, columnRequested) && (<UnsortedColumn columnId={columnRequested} />)}
  </NameDescriptionColumns>
);

export default WorkspacesTableColumns;
